import { Component, OnInit } from '@angular/core';
import { JavaService } from 'src/app/java.service';

@Component({
    selector: 'app-pin-mismatch',
    templateUrl: './pin-mismatch.component.html',
    styleUrls: ['./pin-mismatch.component.css']
})
export class PinMismatchComponent implements OnInit {

    constructor(
        private _java: JavaService,
    ) { }

    ngOnInit(): void {
    }

    onBack() {
        this._java.javaConnector.goBack();
    }
}
